import { types } from 'mobx-state-tree';

export default types.model('OrderProperty',
    {
        OrderPropertyId: types.identifier,
        Key: types.string,
        Value: types.string
    });
